/*
 * @@Author: zhouwei
 * @Date: 2024-08-05 09:33:35
 * @Description:
 */

import { PAGE_URLS } from '@common/consts';
import { toLocale } from '@common/i18n';

export const PAGE_PATH = {
  TWITTER: 'https://twitter.com/OKCoinJapan',
  STAKING: '/earn/staking',
  CURRENCY_INFO: '/currency/',
  SPOT: PAGE_URLS.trade,
};

export const PARENT_MENU = [
  {
    path: '/sale',
    name: toLocale('currency_breadcrumbs_sale_title'),
  },
  {
    path: PAGE_URLS.trade,
    name: toLocale('currency_breadcrumbs_trade_title'),
  },
];

export const EVENT_EMITTER_KEYS = {
  currencyPrice: 'CURRENCY_PRICE',
};

export const PLACEHOLDER = '--';
